import { render, staticRenderFns } from "./OCRManagementList.vue?vue&type=template&id=e37e1372&scoped=true&"
import script from "./OCRManagementList.vue?vue&type=script&lang=ts&"
export * from "./OCRManagementList.vue?vue&type=script&lang=ts&"
import style0 from "./OCRManagementList.vue?vue&type=style&index=0&id=e37e1372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37e1372",
  null
  
)

export default component.exports